import React from 'react';
import { Button } from '@/components/ui/button';
import { BillingCategory } from '@/types/billing';
import { Bell, Receipt, Calendar, Gift, Banknote, HeartHandshake, RefreshCw } from 'lucide-react';

interface BillingCategoryToggleProps {
  activeCategory: BillingCategory;
  onCategoryChange: (category: BillingCategory) => void;
  onCalendarClick?: () => void;
  showCalendar?: boolean;
}

const BillingCategoryToggle: React.FC<BillingCategoryToggleProps> = ({
  activeCategory,
  onCategoryChange,
  onCalendarClick,
  showCalendar = false
}) => {
  return (
    <div className="flex items-center gap-2 mb-6">
      <Button
        variant={!showCalendar && activeCategory === 'LEMBRETE' ? 'default' : 'ghost'}
        onClick={() => onCategoryChange('LEMBRETE')}
        className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all ${
          !showCalendar && activeCategory === 'LEMBRETE'
            ? 'bg-orange-500 hover:bg-orange-600 text-white font-bold'
            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
        }`}
      >
        <Bell className="w-4 h-4" />
        Lembrete
      </Button>
      
      <Button
        variant={!showCalendar && activeCategory === 'COBRANÇA' ? 'default' : 'ghost'}
        onClick={() => onCategoryChange('COBRANÇA')}
        className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all ${
          !showCalendar && activeCategory === 'COBRANÇA'
            ? 'bg-orange-500 hover:bg-orange-600 text-white font-bold'
            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
        }`}
      >
        <Receipt className="w-4 h-4" />
        Cobrança
      </Button>

      <Button
        variant={!showCalendar && activeCategory === 'BOAS-VINDAS' ? 'default' : 'ghost'}
        onClick={() => onCategoryChange('BOAS-VINDAS')}
        className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all ${
          !showCalendar && activeCategory === 'BOAS-VINDAS'
            ? 'bg-amber-500 hover:bg-amber-600 text-white font-bold'
            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
        }`}
      >
        <HeartHandshake className="w-4 h-4" />
        Boas-Vindas
      </Button>

      <Button
        variant={!showCalendar && activeCategory === 'RENOVAÇÃO' ? 'default' : 'ghost'}
        onClick={() => onCategoryChange('RENOVAÇÃO')}
        className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all ${
          !showCalendar && activeCategory === 'RENOVAÇÃO'
            ? 'bg-cyan-600 hover:bg-cyan-700 text-white font-bold'
            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
        }`}
      >
        <RefreshCw className="w-4 h-4" />
        Renovação
      </Button>

      <Button
        variant={!showCalendar && activeCategory === 'ANIVERSÁRIO' ? 'default' : 'ghost'}
        onClick={() => onCategoryChange('ANIVERSÁRIO')}
        className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all ${
          !showCalendar && activeCategory === 'ANIVERSÁRIO'
            ? 'bg-rose-500 hover:bg-rose-600 text-white font-bold'
            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
        }`}
      >
        <Gift className="w-4 h-4" />
        Aniversário
      </Button>

      <Button
        variant={!showCalendar && activeCategory === 'PAGAMENTO' ? 'default' : 'ghost'}
        onClick={() => onCategoryChange('PAGAMENTO')}
        className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all ${
          !showCalendar && activeCategory === 'PAGAMENTO'
            ? 'bg-emerald-500 hover:bg-emerald-600 text-white font-bold'
            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
        }`}
      >
        <Banknote className="w-4 h-4" />
        Pagamento
      </Button>

      {(activeCategory === 'COBRANÇA' || activeCategory === 'LEMBRETE') && onCalendarClick && (
        <Button
          variant={showCalendar ? 'default' : 'outline'}
          onClick={onCalendarClick}
          className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all ${
            showCalendar
              ? 'bg-blue-500 hover:bg-blue-600 text-white'
              : 'border-gray-300 text-gray-700 hover:bg-gray-50'
          }`}
        >
          <Calendar className="w-4 h-4" />
          Calendário
        </Button>
      )}
    </div>
  );
};

export default BillingCategoryToggle;
